<template>
  <div class="column is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
    <b-field :label="label">
      <b-tooltip :label="tooltip" position="is-bottom">
        <b-datepicker
          :id="id"
          v-model="auxValue"
          rounded
          size="is-small"
          :position="position"
          :show-week-number="false"
          placeholder="Click to select..."
          icon="calendar-today"
          :date-parser="parser"
          :date-formatter="formatter"
          trap-focus />
      </b-tooltip>
    </b-field>
  </div>
</template>
<script>

export default {
  props: ['id', 'items', 'value', 'label', 'tooltip', 'position'],
  data() {
    return {
      auxValue: new Date()
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.auxValue = this.parser(val);
      }
    },
    auxValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', this.formatter(val));
      }
    }
  },
  methods: {
    parser: str => new Date(str),
    formatter: date => date.toISOString().substring(0, 10)
  }
};
</script>
<style scoped>
</style>
